<template>
  <div class="out-of-stock" v-if="showNotifyMe">
    <h3>Notify me when this product is available</h3>
    <form v-if="!sent">
      <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response">
      <input type="hidden" name="action" value="validate_captcha">
      <input class="sensitive" type="email" v-model="email" autocomplete="email" placeholder="Email address"></input>
      <button id="submit_btn" class="btn--oos" v-if="emailIsValid" @click.prevent="sendRequest">Submit
      </button>
    </form>

    <h4 v-if="error_message">{{ error_message }}</h4>
    <h4 v-if="sent">Thanks! We will notify you when this product becomes available!</h4>
    <h4 v-if="error">{{ submit_error_message }}.</h4>
  </div>
  <div v-else>
    <div class="btn--product-aside btn--product-aside-alt disabled">Out Of Stock</div>
  </div>
</template>

<script>
import backInStock from 'Assets/js/components/backInStock';
import validator from 'Assets/js/components/validator';
import globalTheme from "Assets/js/components/globalTheme";

export default {
  name: "outOfStock",
  props: {
    variants: {
      type: Array,
      required: false,
      default: () => [],
    },
    selected_variant: {
      type: String,
      default: '',
    },
    notify_me_block: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      sent: false,
      error: false,
      selected: this.selected_variant ? this.selected_variant : (this.variants.length > 0 ? this.variants[0].id : ''),
      has_variants: this.variants.length > 1,
      email: '',
      error_message: '',
      submit_error_message: "Please provide a valid email address"
    }
  },
  computed: {
    emailIsValid() {
      const email = this.email.trim();
      const isValid = validator.isValidEmail(email) && email.length > 3;
      this.error_message = isValid || email.length === 0 ? "" : "Please enter a valid email";
      return isValid;
    },
    showNotifyMe() {
      return globalTheme.notifyMeBlockEnabled() && this.notify_me_block;
    }
  },
  methods: {
    sendRequest() {
      const email = this.emailIsValid ? this.email : false;

      if (!email) {
        return;
      }

      backInStock(this.selected, email)
        .then((response) => {
          if (response.status === 200) {
            this.sent = true;
          } else if (response.error) {
            this.error = true;
            this.submit_error_message = response.error;
          }
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.submit_error_message = 'There was an error while submitting you request';
          return false;
        });
    }
  },
}
</script>
